import $ from 'jquery';
import * as Utils from './cmpUtils';

const Plyr = require('plyr');

export default class Brightcove {
  constructor(utag) {
    this.utag = utag;
  }
  init() {
    Brightcove.loadAllVideos(this.utag);
  }
  static loadAllVideos(utag) {
    $('.media-player-div').each((index, element) => {
      Utils.getBrightcoveVideoData($(element).data('videodiv'), (data) => {
        Brightcove.videoDataLoaded(data, element, utag);
      });
    });
  }
  static videoDataLoaded(data, element, utag) {
    const videoSource = Brightcove.getVideoSource(data);
    const videoEl = $(element);
    let controls = [];
    let autoplayinline = '';
    let playsinline = '';
    let loopinline = '';
    let mutedinline = '';
    let constrolsinline = '';
    let captions = '';

    if (videoEl.data('controls') === true) {
      constrolsinline = 'controls';
      controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'fullscreen'];
    }

    if (videoEl.data('autoplay') === true) {
      autoplayinline = 'autoplay';
      mutedinline = 'muted';
      playsinline = 'playsinline';
    }

    if (videoEl.data('loop') === true) {
      loopinline = 'loop';
    }

    if (data.text_tracks.length) {
      data.text_tracks.forEach((obj) => {
        if (obj.kind === 'captions') {
          captions = `<track kind="captions" label="English captions" src="${data.text_tracks[0].src}" srclang="en" default />`;
        }
      });
    }

    // build video
    videoEl.append(`<video crossorigin ${constrolsinline} ${autoplayinline} ${playsinline} ${loopinline} ${mutedinline} id="vid-${videoEl.attr('id')}" class="media-player" poster="${data.poster}" data-name="${videoEl.data('name')}" data-video="${data.id}">
        <source src="${videoSource}" type="video/mp4">
        ${captions}
      </video>`);
    const player = new Plyr(document.getElementById(`vid-${videoEl.attr('id')}`), {
      controls,
    });
    Brightcove.addPlayerListeners(player, utag);
  }
  static getVideoSource(data) {
    // $('#data').append(JSON.stringify(data));
    const videoSourceArray = [];
    for (let i = 0; i < data.sources.length; i += 1) {
      if ('src' in data.sources[i]) {
        const srcToCheck = data.sources[i].src;
        if (srcToCheck.startsWith('https') && srcToCheck.indexOf('mp4')) {
          videoSourceArray.push(data.sources[i]);
        }
      }
    }
    let maxWidth = 0;
    let maxWidthIndex;
    for (let i = 0; i < videoSourceArray.length; i += 1) {
      if (videoSourceArray[i].width > maxWidth) {
        maxWidth = videoSourceArray[i].width;
        maxWidthIndex = i;
      }
    }
    return videoSourceArray[maxWidthIndex].src;
  }
  static addPlayerListeners(element, utag) {
    element.on('play', (e) => {
      const player = e.detail.plyr;
      const videoName = $(e.target).find('video').data('name');

      // fire tag
      utag.fireTag('link', {
        event_name: 'video play',
        video_name: videoName,
        video_length: Math.round(player.duration),
        video_time_viewed: '0',
      });
    });
    element.on('pause', (e) => {
      const player = e.detail.plyr;
      const videoName = $(e.target).find('video').data('name');

      // fire tag
      utag.fireTag('link', {
        event_name: 'video pause',
        video_name: videoName,
        video_time_viewed: Math.round(player.currentTime),
      });
    });
    element.on('enterfullscreen', (e) => {
      const videoName = $(e.target).find('video').data('name');

      // fire tag
      utag.fireTag('link', {
        event_name: 'video full screen on',
        video_name: videoName,
      });
    });
    element.on('exitfullscreen', (e) => {
      const videoName = $(e.target).find('video').data('name');

      // fire tag
      utag.fireTag('link', {
        event_name: 'video full screen off',
        video_name: videoName,
      });
    });
    element.on('ended', (e) => {
      const player = e.detail.plyr;
      const videoName = $(e.target).find('video').data('name');

      // fire tag
      utag.fireTag('link', {
        event_name: 'video completion',
        video_name: videoName,
        video_time_viewed: Math.round(player.currentTime),
      });
    });
  }
}



// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/package/src/js/cmpBrightcoveVideo.js